import React from 'react';
import { Modal, Tabs } from 'antd';
import { useAtom } from 'jotai';
import { settingsModalVisibleAtom, activeSettingsTabAtom } from '../NexaStore';
import { DisableNexa } from './DisableNexa';
import { Options } from './Options';
import { useNexaGateCheck } from '../utils/nexaGateCheck';

const { TabPane } = Tabs;

export const SettingsModal: React.FC = () => {
  const [visible, setVisible] = useAtom(settingsModalVisibleAtom);
  const [activeTab, setActiveTab] = useAtom(activeSettingsTabAtom);
  const { canEnable } = useNexaGateCheck();

  const handleCancel = () => {
    setVisible(false);
    setActiveTab(null);
  };

  const handleTabChange = (key: string) => {
    setActiveTab(key);
  };

  return (
    <Modal
      title={<>&nbsp;</>}
      open={visible}
      onCancel={handleCancel}
      footer={null}
      width={1000}
      destroyOnHidden
    >
      <Tabs
        activeKey={activeTab || 'options'}
        onChange={handleTabChange}
        type="card"
        renderTabBar={() => <></>}
      >
        <TabPane tab="Options" key="options">
          <Options />
        </TabPane>
        {canEnable && (
          <TabPane tab="Disable Nexa" key="disable-nexa">
            <DisableNexa />
          </TabPane>
        )}
      </Tabs>
    </Modal>
  );
};
